import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/password/issue';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/09a8e354-cca9-4655-965b-25ba7679f103?version=eece0979-7062-44ff-a7c4-029575d1e707&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
    bussinessErrorVariant: 'errorService',
  },
  {
    code: '8',
    message: 'Dados do formulário incompleto',
    bussinessErrorVariant: 'wrongParams',
  },
  {
    code: '45',
    message: 'Parametros de entrada insuficientes.',
    bussinessErrorVariant: 'wrongParams',
  },
  {
    code: '46',
    message: 'Não foi possível localizar o membro.',
    bussinessErrorVariant: 'userNotFound',
  },
  {
    code: '57',
    message: 'Nao foi possivel analisar a solicitação de Reset de Senha',
    bussinessErrorVariant: 'errorService',
  },
  {
    code: '54',
    message: 'Nao foi possivel criar a solicitação de Reset de Senha',
    bussinessErrorVariant: 'errorService',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
